import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Application {
  id: string;
  full_name: string;
  email: string;
  phone: string;
  location: string;
  current_occupation: string;
  why_earn: string;
  open_to_mentorship: string;
  commit_time: string;
  follow_structure: string;
  referred_by: string;
  heard_from: string;
  why_selected: string;
  is_qualified: boolean;
  status: string;
  created_at: string;
}

export interface Appointment {
  id: string;
  applicant_name: string;
  email: string;
  phone: string;
  appointment_date: string;
  appointment_time: string;
  is_lagos: boolean;
  physical_address: string | null;
  zoom_link: string | null;
  reminder_sent: boolean;
  reminder_2hr_sent: boolean;
  created_at: string;
}